import { Button } from '@mui/material';
import Image from 'next/image';
import { ZALO_OA_SUPPORT } from '../../../configs/externalLink';
import { ZaloIcon } from '../../../constant/imgImport';
import { OutlinedLockKeyIcon } from '../svgIcon/outlined';

const LockLessonOverlay = () => {
  const handleClickSupport = () => window.open(ZALO_OA_SUPPORT);

  return (
    <div className="flex h-full w-full items-center justify-center rounded-[20px] border border-Other/Outlinedborder-stroke/30 bg-[#EAEAEA]/30 py-16">
      <div className="flex flex-col items-center justify-center gap-4 px-2 py-6 md:gap-6 md:px-10">
        <OutlinedLockKeyIcon className="mx-auto text-Text/Lightbackground/Primary" />
        <p className="text-center text-sm font-medium leading-[120%] text-Text/Lightbackground/Primary">
          Tham gia nhóm để mua và xem toàn bộ nội dung khóa học.
        </p>
        <Button
          onClick={handleClickSupport}
          variant="medium_emphasis_v1"
          className="!min-w-[268px] !gap-2 !text-sm !font-medium !leading-[120%]"
        >
          <Image src={ZaloIcon} alt="zalo icon" width={20} height={20} />
          Liên hệ hỗ trợ
        </Button>
      </div>
    </div>
  );
};

export default LockLessonOverlay;
